import { FIELD_NAMES } from 'modules/projectSettings/constants';
import { ProjectLabel } from 'modules/projectSettings/types';
import { createPositiveToastMessage } from 'modules/projectSettings/utils';
import { addPositiveToast } from 'modules/toastContainer';
import { useController } from 'react-hook-form';
import { useDispatch } from 'react-redux';
import { BUTTON_SIZES, DestructiveButton } from 'ui/button';
import { MODAL_SIZES, MODAL_VARIANTS, Modal, ModalBody, ModalFooter, ModalHeader } from 'ui/modal';
import {
  DeleteLabelPayload,
  ProjectSettingsFormSchemaType,
  useProjectSettingsModalsContext,
} from '../../contexts';

const { LABELS } = FIELD_NAMES;

export const DeleteLabelModal = () => {
  const dispatch = useDispatch();
  const { modalState, hideModal } = useProjectSettingsModalsContext();
  const label = modalState?.payload as DeleteLabelPayload;

  const {
    field: { onChange, value: labels },
  } = useController<ProjectSettingsFormSchemaType>({
    name: LABELS,
  });

  const onSubmit = () => {
    const filteredLabels = (labels as ProjectLabel[]).filter((l) => l.id !== label.id);
    onChange(filteredLabels);
    const message = createPositiveToastMessage('Label', 'deleted');
    dispatch(addPositiveToast(message));
    hideModal();
  };

  return (
    <Modal
      id="delete-label-modal"
      isModalOpen={true}
      onClose={hideModal}
      size={MODAL_SIZES.SMALL}
      variant={MODAL_VARIANTS.DELETE}
    >
      <ModalHeader>Delete label?</ModalHeader>
      <ModalBody>
        Are you sure you want to delete <b>{label.name}</b>? This cannot be undone.
      </ModalBody>
      <ModalFooter onClose={hideModal}>
        <DestructiveButton onClick={onSubmit} size={BUTTON_SIZES.LARGE}>
          Delete label
        </DestructiveButton>
      </ModalFooter>
    </Modal>
  );
};
